import {
  Children,
  isValidElement
} from 'react';
import { isFragment } from 'react-is';

import type {
  PropsWithChildren,
  ReactElement} from 'react';

export const getChildrenAsArrayOfElements = (
  children: PropsWithChildren['children'],
): ReactElement[] => {
  const asArray = Children.toArray(children).filter(
    (node): node is ReactElement => isValidElement(node),
  );

  if (asArray.length !== 1) {
    return asArray;
  }

  // Check if the only child is a fragment ...
  const maybeFragment = asArray[0];

  if (!isFragment(maybeFragment)) {
    return asArray;
  }
  if (!isElementWithProps(maybeFragment)) {
    return asArray;
  }

  // ... and if so, return its children instead.
  // We could make this recursive, but let's not dive too deep into the rabbit hole.
  return Children.toArray(maybeFragment.props.children).filter(
    (node): node is ReactElement => isValidElement(node),
  );
};

export function isNonNullable<T>(check: T): check is NonNullable<T> {
  return check !== null && check !== undefined;
}

export function isElementWithProps<P extends Record<string, any>>(
  element: any,
): element is ReactElement<P> {
  return isValidElement(element) && element.props !== undefined;
}
